// Referral Form 1048 — BDU-styled referral (refurl) lead form, a clone of
// Referral Form 1008 restyled to https://www.bduedu.in/refurl. Same collected
// fields (name, email, phone → OTP) and the same referral tagging from the URL;
// what differs is the chrome: a white logo bar, a background strip with artwork
// hanging off its right edge, underlined inputs and BDU's red gradient on the
// form header, the submit button and the resend link.
//
// COLUMN REUSE — 1048 needs two gradients where 1008 had flat colours, so the
// banner-overlay `gradient_*` trio (unused by 1008) drives the FORM HEADER bar
// here and is labelled that way, while the submit/resend gradient runs
// `button_color` → `button_color_2`. `thank_you_mobile_image` is deliberately
// absent: BDU keeps the same background on the thank-you step.

export const REFERRAL_FORM_1048_DEFAULT_BANNER_TITLE =
  "<h2>Greetings!</h2><p>Thank you for showing your interest.</p>";
export const REFERRAL_FORM_1048_DEFAULT_FORM_TITLE = "Send Us a Message";
export const REFERRAL_FORM_1048_DEFAULT_BACKGROUND_IMAGE =
  "/images/bdu_refurl_bg.png";
export const REFERRAL_FORM_1048_DEFAULT_SIDE_IMAGE =
  "/images/bdu_refurl_creative.png";
/** Form header bar — v1's `bg-gradient-to-r from-[#F20113] to-[#A20113]`. */
export const REFERRAL_FORM_1048_HEADER_GRADIENT_ANGLE = "to right";
export const REFERRAL_FORM_1048_HEADER_GRADIENT_START = "#F20113";
export const REFERRAL_FORM_1048_HEADER_GRADIENT_END = "#A20113";
/** Submit / resend — v1's `bg-button-gradient-red`. */
export const REFERRAL_FORM_1048_BUTTON_GRADIENT_START = "#FF0013";
export const REFERRAL_FORM_1048_BUTTON_GRADIENT_END = "#990013";

export const REFERRAL_FORM_1048_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    logo_image: "",
    logo_alt: "Logo",
    desktop_image: "",
    mobile_image: "",
    side_image: "",
    alt_image: "Referral form background",
    banner_title: "",
    gradient_angle: REFERRAL_FORM_1048_HEADER_GRADIENT_ANGLE,
    gradient_start_color: REFERRAL_FORM_1048_HEADER_GRADIENT_START,
    gradient_end_color: REFERRAL_FORM_1048_HEADER_GRADIENT_END,
    form_title_text: REFERRAL_FORM_1048_DEFAULT_FORM_TITLE,
    form_title_color: "#FFFFFF",
    button_text: "Submit",
    button_text_color: "#FFFFFF",
    button_color: REFERRAL_FORM_1048_BUTTON_GRADIENT_START,
    button_color_2: REFERRAL_FORM_1048_BUTTON_GRADIENT_END,
  },

  REFERRAL_FORM_FIELDS_CONFIG: [
    {
      fieldName: "logo_image",
      label: "Logo Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_alt",
      label: "Logo Alt Text",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for logo",
      required: false,
      defaultValue: "Logo",
    },
    {
      fieldName: "desktop_image",
      label: "Desktop Background Strip Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Strip Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile Background Strip Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Strip Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "side_image",
      label: "Side Artwork Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload the artwork shown at the right of the strip",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Referral form background",
    },
    {
      fieldName: "banner_title",
      label: "Banner Title",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter banner title and sub-title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_angle",
      label: "Form Header Gradient Angle",
      value: REFERRAL_FORM_1048_HEADER_GRADIENT_ANGLE,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. to right or 90deg",
      required: false,
      defaultValue: REFERRAL_FORM_1048_HEADER_GRADIENT_ANGLE,
    },
    {
      fieldName: "gradient_start_color",
      label: "Form Header Gradient Start Color",
      value: REFERRAL_FORM_1048_HEADER_GRADIENT_START,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header gradient start color",
      required: false,
      defaultValue: REFERRAL_FORM_1048_HEADER_GRADIENT_START,
    },
    {
      fieldName: "gradient_end_color",
      label: "Form Header Gradient End Color",
      value: REFERRAL_FORM_1048_HEADER_GRADIENT_END,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header gradient end color",
      required: false,
      defaultValue: REFERRAL_FORM_1048_HEADER_GRADIENT_END,
    },
    {
      fieldName: "form_title_text",
      label: "Form Header Title",
      value: REFERRAL_FORM_1048_DEFAULT_FORM_TITLE,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter form header title",
      required: false,
      defaultValue: REFERRAL_FORM_1048_DEFAULT_FORM_TITLE,
    },
    {
      fieldName: "form_title_color",
      label: "Form Header Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header title color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Submit",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      required: false,
      defaultValue: "Submit",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_color",
      label: "Button Gradient Start Color",
      value: REFERRAL_FORM_1048_BUTTON_GRADIENT_START,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button gradient start color",
      required: false,
      defaultValue: REFERRAL_FORM_1048_BUTTON_GRADIENT_START,
    },
    {
      fieldName: "button_color_2",
      label: "Button Gradient End Color",
      value: REFERRAL_FORM_1048_BUTTON_GRADIENT_END,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button gradient end color",
      required: false,
      defaultValue: REFERRAL_FORM_1048_BUTTON_GRADIENT_END,
    },
  ],

  METADATA_FIELDS: [],
};
